export default __webpack_public_path__ + "static/media/Fatal Hyperborean Sentinel Gem.18e74585.jpg";